import React, { useCallback, useMemo, useState } from 'react';
import { Box, DownloadIcon, List, PDFIcon, PlusMoneyIcon, RawButton } from '@common-fe/common-fe';

import ExcessContributionWithdrawModal from '@/components/modals/ExcessContributionWithdrawModal/ExcessContributionWithdrawModal';

import { useDownloadTaxFile } from './hooks';
import { ITaxForm, ITaxFormType } from './TaxForms.types';

interface Props extends ITaxForm {
  highlightedTaxFormId?: string;
  isOpenHSAExist?: boolean;
}

const TaxFormsItem: React.FC<Props> = ({ id, name, type, highlightedTaxFormId, isOpenHSAExist, ...rest }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const isTaxFormExcess = useMemo(() => type === ITaxFormType.TaxFormExcess1099, [type]);
  const isHighlighted = useMemo(() => highlightedTaxFormId === `${id}`, [highlightedTaxFormId, id]);
  const { handleDownload, handleOpenPreview } = useDownloadTaxFile({
    id,
    name,
    type,
    ...rest,
  });
  const handleViewExcessContribution = useCallback(() => setModalVisible(true), [setModalVisible]);

  return (
    <>
      {isModalVisible ? <ExcessContributionWithdrawModal onSetVisible={setModalVisible} id={id} /> : null}
      <List.Item testId={`tax-form_item_${id}`} isHighlighted={isHighlighted}>
        {isTaxFormExcess ? (
          <Box
            width="32px"
            height="32px"
            background="nonClaimBg"
            align="center"
            justify="center"
            round="fieldRound"
          >
            <PlusMoneyIcon color="nonClaimIcon" />
          </Box>
        ) : (
          <Box
            pad="xxs"
            data-testId={`tax-form_item_${id}_pdf-icon`}
            round="fieldRound"
            border={{ size: 'small', color: 'border1' }}
          >
            <PDFIcon />
          </Box>
        )}
        <List.Item.Link
          testId={`tax-form_item_${id}_name`}
          margin={{ left: 's' }}
          onClick={isTaxFormExcess && isOpenHSAExist ? handleViewExcessContribution : handleOpenPreview}
        >
          {name}
        </List.Item.Link>

        {isTaxFormExcess ? null : (
          <RawButton data-testId={`tax-form_item_${id}_download-icon`} onClick={handleDownload}>
            <DownloadIcon color="iconPrimary" />
          </RawButton>
        )}
        <Box margin={{ left: 's' }}>
          <List.Item.Options testId={`tax-form_item_${id}_options`}>
            <List.Item.Options.Item
              testId={`tax-form_item_${id}_options_view`}
              onClick={isTaxFormExcess && isOpenHSAExist ? handleViewExcessContribution : handleOpenPreview}
            >
              View
            </List.Item.Options.Item>
            {isTaxFormExcess ? null : (
              <List.Item.Options.Item
                testId={`tax-form_item_${id}_options_download`}
                onClick={handleDownload}
              >
                Download
              </List.Item.Options.Item>
            )}
          </List.Item.Options>
        </Box>
      </List.Item>
    </>
  );
};

export default TaxFormsItem;
